import { commitSha } from 'src/utils/commit-sha';
import { metaJson } from 'src/utils/fetch-meta-json';

/**
 * In the majority of the cases a "new release" means it is
 * a newer version of the frontend that is available. In exceptional cases
 * it could also refer to a rollback to a previous version.
 */
export function isNewReleaseAvailable(): boolean {
  return metaJson.value !== undefined && metaJson.value.commitSha !== commitSha;
}
